// extracted by mini-css-extract-plugin
export default {"root":"EmbeddedAppUnprocessable_root__a0TP9","heading":"EmbeddedAppUnprocessable_heading__dHuRa"};